import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 28, className }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.75, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, as: Tag = "h1", className, delay = 0, lineClass }) {
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block will-change-transform ${lineClass || ""}`}
            initial={{ y: "112%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.95, delay: delay + i * 0.14, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

export function Eyebrow({ children, light = false }) {
  return (
    <p
      className={`inline-flex items-center gap-2.5 text-xs md:text-sm font-semibold uppercase tracking-[0.2em] ${
        light ? "text-teal-mist" : "text-teal"
      }`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${light ? "bg-gold" : "bg-gold"}`} />
      {children}
    </p>
  );
}

export function CaptionReveal({ children, className, delay = 0.25 }) {
  return (
    <motion.figcaption
      className={className}
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.6, delay, ease: EASE }}
    >
      {children}
    </motion.figcaption>
  );
}